export default __webpack_public_path__ + "static/media/manboxlogo.d7e6748d.jpeg";